import { queryOptions, useQuery } from '@tanstack/react-query';

import { QUERY_STALE_TIME } from '@/config/queryDefaults';

import { marketListApi } from './marketsList.api';

export const marketsListOptions = (verificationToken?: string) =>
  queryOptions({
    queryKey: ['marketsList', verificationToken] as const,
    queryFn: () => marketListApi.getMarketsList(verificationToken),
    staleTime: QUERY_STALE_TIME.stable,
    retry: false
  });

export const useMarketsList = (verificationToken?: string, enabled = true) =>
  useQuery({ ...marketsListOptions(verificationToken), enabled });
